export const Divider = ({ text }: { text: string }) => (
  <div className="flex gap-2.5 items-center text-sm text-white">
    <div className="shrink-0 self-stretch my-auto h-px border border-solid bg-slate-200 border-slate-200 w-[104px]" />
    <div>{text}</div>
    <div className="shrink-0 self-stretch my-auto h-px border border-solid bg-slate-200 border-slate-200 w-[104px]" />
  </div>
);
